const EntitiesEnum = {
  Users: 'users',
};

export default EntitiesEnum;
